// removed by extract-text-webpack-plugin
module.exports = {"userItem":"userItem__1yx8F","userItemLeft":"userItemLeft__3sZEy","userAvatar":"userAvatar__2tYsa","userName":"userName__p7U1f","userBadge":"userBadge__2cODJ","userItemRight":"userItemRight__udRHf","userFollowButton":"userFollowButton__2kBSR"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Organizers/UserItem.css
// module id = 1369
// module chunks = 0